module.exports = __webpack_public_path__ + "static/kazim-yardimci-3-c74493c6a0ce51ce770d16e607d1998e.jpg";